'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactRedux = require('react-redux');
var userSessionStoreCore = require('@zillow/user-session-store-core');

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();













var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Combines global state (if exists) with local state before passed off to mapStateToProps.
 * @param {Function} selector - mapper of combined state to plain object to be merged into component props
 * @param {String} globalKey - optional namespacing key for global state values
 * @return {Function} mapStateToProps state to object props mapper
 */
function combineUserSessionStateToProps(selector) {
    var globalKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return function (localState, localOwnProps) {
        if (typeof selector === 'undefined') {
            throw new Error('selector not specified');
        }

        var globalState = userSessionStoreCore.hasUserSessionStore() ? userSessionStoreCore.getUserSessionStore().getState() : {};

        if (globalKey !== '') {
            return selector(_extends({}, localState, defineProperty({}, globalKey, globalState)), localOwnProps);
        }

        return selector(_extends({}, globalState, localState), localOwnProps);
    };
}

/**
 * UserSession wrapper for redux connect.
 * @param {Function} mapStateToProps - (state, ownProps) => {...} (must return object)
 * @return {Class} higher-order React component class
 */
function connectToUserSession(mapStateToProps, mapDispatchToProps, mergeProps, options) {
    return reactRedux.connect(function (state) {
        return combineUserSessionStateToProps(mapStateToProps)(state);
    }, mapDispatchToProps, mergeProps, _extends({ pure: false }, options) // prevent memoization by default
    );
}

exports.combineUserSessionStateToProps = combineUserSessionStateToProps;
exports['default'] = connectToUserSession;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/user-session-store-connect/lib/index.js
// module id = 587
// module chunks = 1